import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/case_package/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true,},
        {text: 'dgs_status', value: 'dgs_status', sortable: false, divider: true, width: 60},
        {text: 'Teach complete', value: 'teach_complete_common', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Need common XML', value: 'need_common', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Exists common XML', value: 'exists_common_xml', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Teach complete resistor', value: 'teach_complete_resistor', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Need resistor XML', value: 'need_resistor', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Exists resistor XML', value: 'exists_resistor_xml', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Teach complete capacitor', value: 'teach_complete_capacitor', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Need capacitor XML', value: 'need_capacitor', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Exists capacitor XML', value: 'exists_capacitor_xml', sortable: false, divider: true, type: 'bool', width: 30},
        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['name'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        CasePackageTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}